import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Checkbox, FormControlLabel, Stack, TextField } from '@mui/material';

import navOnlineService from '../../service/navOnline.service';

const NavOnlineManualAcceptance = ({ documentTypeId, documentId, communicationId, onAccepted, onBusyChange }) => {
  const [expanded, setExpanded] = useState(false);
  const [note, setNote] = useState('');
  const [reference, setReference] = useState('');
  const [confirmed, setConfirmed] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const alive = useRef(false);
  const busy = useRef(false);
  useEffect(() => {
    alive.current = true;
    return () => { alive.current = false; onBusyChange?.(false); };
  }, [onBusyChange]);

  const accept = async () => {
    if (busy.current) return;
    if (!confirmed || !note.trim()) { setError('A NAV-rögzítés megerősítése és az indoklás kötelező.'); return; }
    busy.current = true;
    setSaving(true);
    setError('');
    onBusyChange?.(true);
    try {
      const data = await navOnlineService.manuallyAcceptInvoice(documentTypeId, documentId, {
        expectedCommunicationId: communicationId, note: note.trim(), reference: reference.trim() || undefined,
        registeredInNav: true,
      });
      if (alive.current) onAccepted?.(data);
    } catch (reason) {
      if (alive.current) setError(reason?.response?.data?.error?.message || 'A manuális NAV-elfogadás mentése sikertelen.');
    } finally {
      busy.current = false;
      if (alive.current) { setSaving(false); onBusyChange?.(false); }
    }
  };

  if (!expanded) return <Button type="button" variant="outlined" onClick={() => setExpanded(true)}>Manuális elfogadás</Button>;
  return (
    <Stack spacing={2}>
      <Alert severity="info">
        Akkor fogadd el manuálisan a számlát, ha azt már rögzítetted a NAV Online Számla felületén.
        A rendszer külön jelöli ezt az elfogadást, leállítja az újraküldést és a hibaértesítéseket.
      </Alert>
      {error && <Alert severity="error">{error}</Alert>}
      <TextField label="Manuális elfogadás indoklása" value={note} onChange={(event) => setNote(event.target.value)}
        disabled={saving} required multiline minRows={2} inputProps={{ maxLength: 2000 }} />
      <TextField label="NAV-hivatkozás (nem kötelező)" value={reference} onChange={(event) => setReference(event.target.value)}
        disabled={saving} inputProps={{ maxLength: 100 }} />
      <FormControlLabel label="Megerősítem, hogy a számlát rögzítettem a NAV Online Számla felületén."
        control={<Checkbox checked={confirmed} onChange={(event) => setConfirmed(event.target.checked)} disabled={saving} />} />
      <Stack direction="row" spacing={1}>
        <Button type="button" variant="contained" disabled={saving || !confirmed || !note.trim()} onClick={accept}>
          {saving ? 'Mentés…' : 'Manuális elfogadás mentése'}
        </Button>
        <Button type="button" disabled={saving} onClick={() => { setExpanded(false); setError(''); }}>Mégse</Button>
      </Stack>
    </Stack>
  );
};

export default NavOnlineManualAcceptance;
